import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://4da5466d47fba9fa627425477b3c8ab1@o4507176040660992.ingest.de.sentry.io/4507855970041936",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    environment: 'production',
    // Tracing
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
    <Provider store={store}>
        <App />
    </Provider>
    );

